var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5002C8.10625 27.5002 2.5 21.8927 2.5 15.0002C2.5 8.10774 8.10625 2.50024 15 2.50024C21.8925 2.50024 27.5 8.10774 27.5 15.0002C27.5 21.8927 21.8925 27.5002 15 27.5002Z",
    fill: "#C7C7C7",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8025 20.2761C16.5638 20.2761 16.3238 20.1848 16.1413 20.0023L11.7825 15.6648C11.6063 15.4886 11.5075 15.2498 11.5075 14.9998C11.5075 14.7511 11.6063 14.5123 11.7825 14.3361L16.1413 9.99609C16.5075 9.63109 17.1 9.63109 17.4663 9.99859C17.8313 10.3661 17.83 10.9598 17.4638 11.3248L13.7725 14.9998L17.4638 18.6748C17.83 19.0398 17.8313 19.6323 17.4663 19.9998C17.2838 20.1848 17.0425 20.2761 16.8025 20.2761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlack);
export default __webpack_public_path__ + "static/media/arrow-left-black.f59e36355a45ecafd1a34b93000fa802.svg";
export { ForwardRef as ReactComponent };